import Image from "next/image";

export default function Feature({
                                    icon,
                                    title,
                                    body,
                                    bodyColor = 'white',
                                    className = '',
                                    bodyClassName = 'max-w-[36ch]'
                                }) {
    return (
        <div className={`flex flex-col gap-6 items-center ${className}`}>
            {icon && (
                <div className="flex w-20 h-20">
                    <Image src={icon}
                           priority
                           alt={`${title} Icon`}
                    />
                </div>
            )}
            <h3 className="text-xl">{title}</h3>
            <p className={`text-sm ${bodyColor === 'white' ? 'text-white' : 'text-black'} leading-relaxed ${bodyClassName}`}
               dangerouslySetInnerHTML={{__html: body}}/>
        </div>
    )
}
